"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = exports.Formik = exports.FieldTextarea = exports.FormCustomSwitch = exports.FormCustomCheckBoxGroup = exports.FormCustomCheckBox = exports.FieldError = exports.FormLabel = exports.FormSubmit = exports.FormSelect = exports.FieldWrapper = exports.Field = exports.FormCheckbox = exports.FlatFormButton = exports.FormButton = void 0;
exports.getInvalidStyle = getInvalidStyle;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
var Button_1 = require("./Button");
Object.defineProperty(exports, "FormButton", { enumerable: true, get: function () { return Button_1.FormButton; } });
Object.defineProperty(exports, "FlatFormButton", { enumerable: true, get: function () { return Button_1.FlatFormButton; } });
var Checkbox_1 = require("./Checkbox");
Object.defineProperty(exports, "FormCheckbox", { enumerable: true, get: function () { return Checkbox_1.Checkbox; } });
var Field_1 = require("./Field");
Object.defineProperty(exports, "Field", { enumerable: true, get: function () { return Field_1.Field; } });
var FieldWrapper_1 = require("./FieldWrapper");
Object.defineProperty(exports, "FieldWrapper", { enumerable: true, get: function () { return FieldWrapper_1.FieldWrapper; } });
var Select_1 = require("./Select");
Object.defineProperty(exports, "FormSelect", { enumerable: true, get: function () { return Select_1.Select; } });
var Submit_1 = require("./Submit");
Object.defineProperty(exports, "FormSubmit", { enumerable: true, get: function () { return Submit_1.Submit; } });
var Label_1 = require("./Label");
Object.defineProperty(exports, "FormLabel", { enumerable: true, get: function () { return Label_1.Label; } });
var FieldError_1 = require("./FieldError");
Object.defineProperty(exports, "FieldError", { enumerable: true, get: function () { return FieldError_1.FieldError; } });
var CustomCheckBox_1 = require("./CustomCheckBox");
Object.defineProperty(exports, "FormCustomCheckBox", { enumerable: true, get: function () { return CustomCheckBox_1.CustomCheckBox; } });
var CustomCheckBoxGroup_1 = require("./CustomCheckBoxGroup");
Object.defineProperty(exports, "FormCustomCheckBoxGroup", { enumerable: true, get: function () { return CustomCheckBoxGroup_1.CustomCheckBoxGroup; } });
var CustomSwitch_1 = require("./CustomSwitch");
Object.defineProperty(exports, "FormCustomSwitch", { enumerable: true, get: function () { return CustomSwitch_1.CustomSwitch; } });
var FieldTextarea_1 = require("./FieldTextarea");
Object.defineProperty(exports, "FieldTextarea", { enumerable: true, get: function () { return FieldTextarea_1.FieldTextarea; } });
var formik_1 = require("formik");
Object.defineProperty(exports, "Formik", { enumerable: true, get: function () { return formik_1.Formik; } });
Object.defineProperty(exports, "Form", { enumerable: true, get: function () { return formik_1.Form; } });
function getInvalidStyle(invalid, colour) {
    return `border: ${invalid ? `2px solid ${colour}` : "none"};`;
}
//# sourceMappingURL=index.js.map